import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
export default class OutOfMemoryError extends Exception {
}
//# sourceMappingURL=OutOfMemoryError.js.map